'use client';

import { Menu } from '@base-ui/react/menu';
import Link from 'next/link';

import { HELP_CENTER_HREF } from './nav-data';

export function MoreMenu() {
  return (
    <Menu.Root>
      <Menu.Trigger
        aria-label="More"
        className="inline-flex h-10 w-10 items-center justify-center rounded-full text-ink transition hover:bg-state-hover"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="4" cy="10" r="1.6" fill="currentColor" />
          <circle cx="10" cy="10" r="1.6" fill="currentColor" />
          <circle cx="16" cy="10" r="1.6" fill="currentColor" />
        </svg>
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Positioner sideOffset={8} align="end" className="z-50">
          <Menu.Popup className="min-w-[200px] rounded-2xl border border-line-soft bg-canvas p-2 shadow-lg">
            <Menu.Item
              className="block rounded-xl px-4 py-3 text-ink outline-none transition data-[highlighted]:bg-state-hover text-body-md"
              render={<Link href={HELP_CENTER_HREF} prefetch={false} />}
            >
              Help center
            </Menu.Item>
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
}
